import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberArray'
})
export class NumberArrayPipe implements PipeTransform {
  transform(value: string): number[] {
    return value.split(',').map(Number);
  }
}
